fourToldApp.controller("managedSessionCntrl", function(conversation_history,cryptool, session, xmppAuth, theme, $controller, templates, esb, $scope, $localStorage, services, $window, $location, $rootScope, $httpParamSerializer, $cookieStore, $q, $mdToast, $mdDialog, countryCode, countries, $sce, $locale, countriesList) {
    $scope.progressCircular = true;
    $scope.message = "Iniciando proceso de autorización";
    $scope.theme = theme.getTheme();
    $scope.managedConfig = $location.search()._managed;
    $window.localStorage.removeItem("access_token1"); // remove token when managed-session page is opened
    $scope.progressCircular = false;
    $scope.tag = $location.search().tag;
    $scope.action = $location.search().action;
    $scope.hideMenu = false;
    $scope.loaded = false;
    $scope.changeValue = function (data) {
        $scope.progressCircular = false;
        $scope.token = data.data.token;
        let el = document.getElementById('message_container');
        if (el){
            el.innerText = "received token: "+ data.data.token+"\n";
        }
        console.log('cambiando valor');
        $scope.message = "Token recibido, verificando, usuario";
        console.log($scope.message);
        $scope.getCustomer($scope.token);
    }
    var userData = {};

    if($location.search().tag !== undefined && $location.search().tag !== null){
        $window.sessionStorage.removeItem("theme");
        services.specificTag().theme({tag:$location.search().tag}, function(response) {
          switch(response.code) {
              case 1:
                if(response.data && response.data[0].field4 !== undefined){
                    $window.sessionStorage.setItem("theme",response.data[0].field4); 
                    $scope.theme = theme.getTheme();
                }
                break;
              case -31:
                  favicon.setIcon("/images/icons/logo/favicon-32x32.png");        
                  break;
              }
        }, function error(response) {console.log("error tag")});
      }


    $scope.getCustomer = function (token) {
        services.externalRegisterDataSearch(token).search({tag : $scope.tag}, {}, function(status, response) {
            if(status.code === -2) { // user not found
                $scope.progressCircular = false;
                $scope.message = "Token inválido o usuario no existe";
            } else if (status.code === -500) {
                $scope.progressCircular = false;
                $scope.message = "Ocurrió un error verificando el token";
            } else if (status.code === 1) {  // OK
                $scope.message = "Token válido, registrando usuario";
                $scope.userData = status.data;
                $scope.registerCustomer($scope.userData);
            } else {
                $scope.progressCircular = false;
                $scope.message = "Servicio no disponible";
            }

        });
    }

    $scope.registerCustomer = function (body) {
        services.externalUserRegister('Bearer ').register({}, body, function(status, response) {
            if(status.code === -2) { // user not found
                $scope.message = "Token inválido o usuario no existe";
            } else if (status.code === -500) {
                $scope.message = "Ocurrió un error registrando el usuario";
            } else if (status.code === -1) {  // OK
                $scope.doLogin(status.data);
            } else if (status.code === 1) {  // OK
                $scope.doLogin(status.data);

            } else {
                $scope.message = "Servicio no disponible";
            }

        });
    }

    $scope.doLogin = function (data, managed, isRetry) {
        $scope.registedUser = data;

        $scope.message = "Autorización exitosa, accediendo a plataforma...";

        $scope.dialCode = data.phonePrefix;
        $scope.username = data.phoneNumber;
        $scope.password = data.password;

        if (managed){
            let sessionToken = data.access_token;
            let refreshToken = data.refresh_token;
            $scope.submitTagExternal($scope.tag, sessionToken, refreshToken, isRetry);
        } else {
            $scope.submit(true,true);
        }
    }

    $scope.submitTagExternal = function(tag, sessionToken, refreshToken, isRetry) {
        $window.sessionStorage.setItem('registerTag', tag);
        var now = new $window.Date(),
            exp = new $window.Date(now.getFullYear(), now.getMonth() + 6, now.getDate());
        $scope.tokenLogOut = 'bearer ' + sessionToken;

        tag = services.tag('bearer '+sessionToken).theme({}, function(response) {
            if(response.data[0] && response.data[0].properties[0]!== undefined){
                $window.sessionStorage.setItem("theme",response.data[0].properties[0].field4);
                $scope.theme = theme.getTheme(); 
            } else{
                $window.sessionStorage.removeItem("theme");
            }
        }, function error(response) {
            console.log("error tag");
        });

        userPhoto = services.user.userServices('bearer ' + sessionToken).userPhoto({}, function(response) {
            services.user.setPhoto(response.data);
        }, function error(response) {
            console.log("error user photo");
        });
        channel = services.channel('bearer ' + sessionToken).alternatechannels({}, function(response) {
            var channel = [] = response.data;
            response.data.forEach(element => element.unread = 0);
            $localStorage.channel = channel;
        }, function error(response) {
            console.log("Error in service Channel");
        });
        userData = services.user.userServices('bearer ' + sessionToken).userData({}, function(response) {
            if (response.data) {
                var permissions = new Array();
                var rolesToUser = response.data.userInfo.rolesToUser;
                for(var roleToUser of rolesToUser) {
                    var role = roleToUser.role;
                    var rolesToPermission = role.rolesToPermission;
                    for(var roleToPermission of rolesToPermission) {
                        var permission = roleToPermission.permission;
                        permissions.unshift(permission.code);
                        if( permission.code == "SCN_BASIC_GROUPS" || permission.code == "SCN_ADMIN_GROUPS") {
                            response.data.userInfo.hasGroupPermissions = true;
                            if(permission.code == "SCN_ADMIN_GROUPS") {
                                response.data.userInfo.hasGroupAdminPermissions = true;
                            }
                        }
                    }
                }

                response.data.userInfo.permissions = permissions;
                services.user.setData(response.data.userInfo);

                $window.sessionStorage.setItem('requiredPasswordChange', response.data.userInfo.requiredPasswordChange);

                if(response.data.userInfo.properties && response.data.userInfo.properties._openfireContactServer) {
                    $window.sessionStorage.setItem("openfireContactServer",cryptool.encryptData(response.data.userInfo.properties._openfireContactServer + "@" + userData.data.userInfo.xmppConfig.serviceName));
                } else {
                    $window.sessionStorage.setItem("openfireContactServer",cryptool.encryptData("aga.dev@" + response.data.userInfo.xmppConfig.serviceName));
                }

            }
        }, function(error) {
            if(error && error.status === 503 && error.data && error.data.code === -503) {
                $scope.loginError = undefined;
                $window.localStorage.removeItem("access_token1");
                $scope.showAlert("Acceso denegado", "El sistema no está disponible en estos momentos");
            }
            console.log("error user data ", error);
        });
        $q.all([
            userData.$promise,
            userPhoto.$promise
        ]).then(function() {
            if (userData.data) {
                window.top.postMessage({type:'login', token: sessionToken}, '*');
                $window.sessionStorage.setItem( "userXmpp", userData.data.userInfo.xmppConfig.username);
                $window.sessionStorage.setItem( "passwordXmpp", cryptool.encryptData(userData.data.userInfo.xmppConfig.password));
                $window.sessionStorage.setItem("serviceName", cryptool.encryptData(userData.data.userInfo.xmppConfig.serviceName));
                $window.sessionStorage.setItem("host", cryptool.encryptData(userData.data.userInfo.xmppConfig.host));
                $localStorage.msg = [];
                services.conversation_history('bearer ' + sessionToken).request({
                    start: 0,
                    maxRows: 60
                }, {}, function(response) {
                    $window.sessionStorage.setItem('conversationsCount', response.conversationsCount);
                    $window.sessionStorage.setItem('originalPageCount', parseInt($window.sessionStorage.getItem('originalPageCount') || 0) + response.conversations.length);
                    conversation_history.setChatData(response, [], 'login', null);
                    var userDataXmpp = userData.data.userInfo.xmppConfig;
                    //xmppAuth.Chat.disconnect();
                    // $window.localStorage.setItem("access_token1", sessionToken, {
                    //     expires: exp
                    // });
                    xmppAuth.Chat.connect(userDataXmpp.username + "@" + userDataXmpp.serviceName, userDataXmpp.password);
                });



                $localStorage.identification_channel =  {
                    "alternateChannelId": null,
                    "alternateChannel" : null
                }
                if (!$rootScope.listenersConfigured){// to avoid configuring listeners more than once
                    $rootScope.$on("iconConnected", function(event, data) {
                        if (data && data === "CONNECTED") {

                            $window.localStorage.setItem("access_token1", sessionToken, {
                                expires: exp
                            });

                            $cookieStore.put("refresh_token", refreshToken, {
                                expires: exp
                            });

                            saveUrlTag();
                            if(userData.data.sessionTimeOutMin!=null){
                                $localStorage.sessionTimeOutMin = userData.data.sessionTimeOutMin * 60;
                            }
                            $locale.NUMBER_FORMATS.DECIMAL_SEP =  ",";
                            $locale.NUMBER_FORMATS.GROUP_SEP =  ".";
                            $localStorage.decimalSeparator = ",";
                            $localStorage.groupSeparator = ".";
                            if(userData.data.decimalSeparator) { 
                                window.localStorage.setItem("decimalSeparator", userData.data.decimalSeparator);
                                  
                             }
                             if(userData.data.groupSeparator) { 
                                 window.localStorage.setItem("groupSeparator", userData.data.groupSeparator);
                                 
                             }

                            if($location.search().tag!=null && $location.search().tag!='undefined' && $location.search().user_teller_agent!=null
                                && $location.search().user_teller_agent!='undefined' && ($window.navigator.userAgent=== 'commerce-mobile' || ($location.search().mode!=null && $location.search().mode === 'asesorweb') )){

                                if($window.navigator.userAgent=== 'commerce-mobile')
                                    $window.sessionStorage.setItem('isAgentWebView', true);

                                $location.search('password', null)
                                $location.search('prefix', null)
                                $location.search('phoneNumber', null)
                                $window.sessionStorage.setItem('sessionType', 'EMBEDDED_AGENT');

                            }
                            else{
                                $window.sessionStorage.setItem('isAgentWebView', false);
                                $window.sessionStorage.setItem('sessionType', 'BORROWER');
                            }


                            if(userData.requiredPasswordChange && !$scope.agentMode && $window.sessionStorage.getItem('isAgentWebView') === "false")
                                $location.path("/change-password");
                            else if(userData.data.userInfo.needConfigureQuestions === true)
                            {
                                if($window.sessionStorage.getItem('isAgentWebView') === "true"){
                                    $window.sessionStorage.setItem('needConfigureQuestions', false);
                                    $rootScope.$apply(function() {
                                        $location.path("/dashboard");
                                    });
                                }
                                else {
                                    if(userData.data.userInfo.activatedConfigureQuestions === true) {
                                        $window.sessionStorage.setItem('needConfigureQuestions', true);
                                        $window.sessionStorage.setItem('activatedConfigureQuestions', true);
                                        $window.localStorage.removeItem("dataQuentions");
                                        $location.path("/quentions");
                                    } else {
                                        $window.sessionStorage.setItem('activatedConfigureQuestions', false);
                                        $window.sessionStorage.setItem('needConfigureQuestions', false);
                                        $rootScope.$apply(function() {
                                            $location.path("/dashboard");
                                        });
                                    }
                                }
                            }
                            else{
                                $window.sessionStorage.setItem('needConfigureQuestions', false);
                                $rootScope.$apply(function() {
                                    $location.path("/dashboard");
                                });
                            }

                        }
                    });
                    $rootScope.listenersConfigured = true; // to avoid configuring listeners more than once
                }
            } else if (userData.code == -403) {
                $scope.loginError = undefined;
                $window.localStorage.removeItem("access_token1");
                $scope.deleteData("Acceso denegado", "Le invitamos a ponerse en contacto con soporte técnico para mayor información");
            } else if (userData.code == -503) {
                $scope.loginError = undefined;
                $window.localStorage.removeItem("access_token1");
                $scope.deleteData("Acceso denegado", "El sistema no está disponible en estos momentos");
            } else if (userData.code == -74 && userData !== null) {
                $scope.loginError = undefined;
                services.closeSession($scope.tokenLogOut).request({}, {}, function(response, event) {
                    console.log("La sesión de usuario ha sido cerrada exitosamente. reintentando...");
                    services.logout($scope.tokenLogOut).post({}, {}, function(response) {
                        $window.localStorage.setItem("retry", 'true');
                        setTimeout(function() {
                            $scope.externalLogin($scope.externalToken, true);
                        },3000);
                    });
                });
            }
        }, function(error) {
            $window.localStorage.removeItem("access_token1");
            if (services.user.getPhoto()) {
                $window.localStorage.removeItem("userPhoto")
            }
            if (services.user.getLogo()) {
                $window.localStorage.removeItem("userLogo")
            }
            if (services.user.getData()) {
                $window.localStorage.removeItem("userData")
            }
        })
    };

    saveUrlTag = function(){
        var urlTag =  $location.url();
        var indexTag = urlTag.indexOf("?tag=");
        if(indexTag>0){

            var url = urlTag.substring(indexTag, urlTag.lenght);
            if(url.includes("password=")) {
                var jsonUrl = $scope.parseToUrl(url);
                url = url.replace("password=" + jsonUrl.password, '');           }

            if(url.includes("phoneNumber="))
            {
                url = url.substring(url.indexOf("phoneNumber="), 0)
            }


            $window.sessionStorage.setItem("urlTag", url);
        }else
        {
            $window.sessionStorage.setItem("urlTag", "");
        }
    };

    $scope.triggerLogout = function(){
        console.log('triggerLogout');
        let win = window.parent;
        win.postMessage({
            "action" : "NOTIFY_LOGOUT",
            "data" : {
                "token" : $scope.token
            }
        }, "*");
    }

    $scope.$on("progressCircular", function(event, data) {
        $scope.progressCircular = data;
        console.log(data);
    });

    if ($window.localStorage.getItem("logout") == 'true'){
        $scope.managedConfig = false;
        $scope.message = $rootScope.managedSessionMessage || "Sesión finalizada";
        delete $rootScope.managedSessionMessage;
        $scope.progressCircular = false;
        $window.localStorage.removeItem("logout");
    }

    $scope.externalLogin = function(externalToken, isRetry){
        services.externalUserRegisterManaged(externalToken).register({tag : $scope.tag, action : $scope.action}, {}, function(response) {
            $scope.progressCircular = false;
            if (response.access_token) {  // OK
                $scope.doLogin(response, true, isRetry);
            } else {
                $scope.message = "Servicio no disponible";
            }
        });
    }

    if ($scope.managedConfig){
        console.log("managed="+$scope.managedConfig);
        if ($scope.managedConfig == '1'){
            $scope.progressCircular = true;
            console.log("managed=1, sending message");
            let win = window.parent;
            win.postMessage({
                "action" : "STATE_REQUEST"
            }, "*");

            window.addEventListener('message', function(event) {
                console.log('message', event);
                if (event.type === "message") {
                    let data = event.data;
                    if (data.action === 'STATE_RESPONSE'){
                        $scope.changeValue(data);
                    } else if (data.action === 'NOTIFY_LOGOUT'){
                        console.log('logout notified from parent');
                        document.getElementById('message_container').innerText += "received logout from parent for token: "+ data.data.token+"\n";
                    }
                }
            });
        } else if ($scope.managedConfig == '2'){
            $scope.hideMenu = true; // hides left side menu
            $scope.externalToken = $location.search()._token;
            $scope.progressCircular = true;
            console.log("managed="+$scope.managedConfig+", token="+$scope.externalToken);
            $scope.externalLogin($scope.externalToken);
        }
    }

});

